var map = {
	"./Geoinformation_solutions.svg": "6dfa",
	"./Logo.svg": "5159",
	"./Triangle_map.svg": "5577",
	"./about_us.svg": "e6d3",
	"./analyze.svg": "0c5e",
	"./career.svg": "1c13",
	"./career_map.svg": "7ca8",
	"./circle_arrow_left.svg": "6dad",
	"./circle_arrow_right.svg": "a4ab",
	"./computer.svg": "ff6a",
	"./contacts.svg": "84ba",
	"./curriculum-vitae.svg": "7bc0",
	"./dashed_arrows.svg": "434e",
	"./data-storage.svg": "4e9f",
	"./folder.svg": "756b",
	"./java.svg": "bf75",
	"./job-interview.svg": "0631",
	"./job.svg": "534c",
	"./kagis_geolocation.svg": "703a",
	"./kazakhstan.svg": "778f",
	"./map-infographic.svg": "f8b3",
	"./mdi_menu.svg": "34a9",
	"./paint-palette.svg": "90a4",
	"./panorama.svg": "6262",
	"./panoramamap.png": "02c1",
	"./partners.svg": "a414",
	"./selection_process.svg": "f5c2",
	"./settings-cog.svg": "7291",
	"./test.svg": "46b0",
	"./web-design.svg": "e69d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";